import React from 'react';
import styled from 'styled-components';
import { BoxSubTitle } from './common';

const Container = styled.div`
  background-color: white;
  box-shadow: 0 2px 12px 0px rgba(0,0,0,0.15);
  border-radius: 10px;
  padding: 17px;
`;

const Link = styled.a`
  -moz-appearance: none;
  -webkit-appearance: none;
  background: none;
  border: none;
  outline: none;
  &::-moz-focus-inner {
    border: 0;
  }
  &:focus {
    outline: none;
  }
  
  all: initial;
  font-weight: bold !important;
  font-size: 16px !important;
  text-decoration: none;
  margin-left: 5px;
  display: inline-block;
  color: #0086C2;
  cursor: pointer;
  border-bottom: 1px solid transparent;
  padding-bottom: 3px;

  &:hover{
    color: #11A9CE;
    border-bottom: 1px solid #11A9CE;
    padding-bottom: 3px;
  }
`;

const LinkText = styled.span`
  &::-moz-focus-inner {
    border: 0;
  }
  &:focus {
    outline: none;
  }
`;

const Webinar = () => (
  <Container>
    <BoxSubTitle>
      Onboarding video for new employees.
      <Link tabIndex="0" href="https://vimeo.com/418556016" target="_blank">
        <LinkText tabIndex="-1">
          Click here.
        </LinkText>
      </Link>
    </BoxSubTitle>
  </Container>
);

export default Webinar;
